export default __webpack_public_path__ + "static/home-731641c6d655c3c8362ff04ffe04505e.png";